module.exports = __webpack_public_path__ + "img/Netto.65e3608d.png";